import React, { useState, useEffect } from 'react';
import { Nav, Navbar, Container, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ManagerNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [managerProfile, setManagerProfile] = useState(null);

  useEffect(() => {
    fetchManagerProfile();
  }, []);

  const fetchManagerProfile = async () => {
    try {
      const token = localStorage.getItem('managerToken');
      if (!token) return;

      const res = await axios.get('/api/manager/profile', {
        headers: { 'x-auth-token': token }
      });
      setManagerProfile(res.data);
    } catch (err) {
      console.error('Error fetching manager profile:', err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('managerToken');
    navigate('/');
  };

  return (
    <Navbar className="modern-navbar" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="navbar-brand-custom">
          <i className="bi bi-qr-code me-2"></i>
          <span className="brand-text">QR Menu</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="manager-nav" className="navbar-toggle-custom" />
        
        <Navbar.Collapse id="manager-nav">
          <Nav className="me-auto nav-links-custom">
            {/* Показываем "Управление меню" только если менеджер может редактировать */}
            {managerProfile?.canManageMenu && (
              <Nav.Link 
                as={Link} 
                to="/admin/menu" 
                className="nav-link-custom"
                active={location.pathname === '/admin/menu'}
              >
                <i className="bi bi-menu-button-wide me-1"></i>
                Управление меню
              </Nav.Link>
            )}
            
            {/* Показываем "Управление заказами" только если менеджер может редактировать */}
            {managerProfile?.canManageMenu && (
              <Nav.Link 
                as={Link} 
                to="/manager/orders" 
                className="nav-link-custom"
                active={location.pathname === '/manager/orders'}
              >
                <i className="bi bi-list-ul me-1"></i>
                Управление заказами
              </Nav.Link>
            )}
            
            {/* Показываем "Управление столами" только если менеджер может редактировать */}
            {managerProfile?.canManageMenu && (
              <Nav.Link 
                as={Link} 
                to="/manager/tables" 
                className="nav-link-custom"
                active={location.pathname === '/manager/tables'}
              >
                <i className="bi bi-table me-1"></i>
                Управление столами
              </Nav.Link>
            )}
            
            {/* Показываем "Управление официантами" только если менеджер - администратор */}
            {managerProfile?.role === 'administrator' && (
              <Nav.Link 
                as={Link} 
                to="/manager/waiters" 
                className="nav-link-custom"
                active={location.pathname === '/manager/waiters'}
              >
                <i className="bi bi-people me-1"></i>
                Управление официантами
              </Nav.Link>
            )}
            
            {/* Показываем "Акции и скидки" только если менеджер - администратор */}
            {managerProfile?.role === 'administrator' && (
              <Nav.Link 
                as={Link} 
                to="/admin/promotions" 
                className="nav-link-custom"
                active={location.pathname === '/admin/promotions'}
              >
                <i className="bi bi-percent me-1"></i>
                Акции и скидки
              </Nav.Link>
            )}
          </Nav>
          
          <Nav className="nav-actions-custom">
            <Button 
              variant="outline-light" 
              onClick={handleLogout}
              className="logout-btn-custom"
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Выйти
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default ManagerNav;
